<template>
  <div id="cards" class="box">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>
    <div class="row">
      <div class="column">
        <div class="row">
          <div class="column">
            <div>
              <transition name="fade" appear>
                <DeploymentsGraph :metrics='metrics'
                    :name='"Deployments"'
                    :date='date'
                    :id="this.id"
                    v-on:updateMetric='updateMetric' />
              </transition>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <transition name="fade" appear>
              <div v-if="displayBoards.length > 0 && activeType == 'group'">
                <div class="card">
                  <h4 class="card-heading">Contracts<span class="board-count">{{ displayBoards.length }}</span></h4>
                  <dl>
                    <template v-for="contract in displayBoards">
                      <dt @mouseover="hoverContract = contract.contract" @mouseout="hoverContract = null" class="contracts" v-bind:class="[ {'hover-contract': (hoverContract == contract.contract)},{'inactive-contract': (hoverContract != contract.contract)} ]" v-on:click="updateContract(contract.contract)" :key=contract.contract>{{ contract.contract }}</dt>
                      <dd :key="contract.contract + contract.count.toString()">{{ contract.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>
            <transition name="fade" appear>
              <div v-if="report.deployments.length > 0 && activeType == 'contract'">
                <div class="card">
                  <h4 class="card-heading">Stacks</h4>
                  <dl>
                    <template v-for="deployment in displayStacks">
                      <dt @click="setActiveStack(deployment.stack_name)" @mouseover="hoverStack = deployment.stack_name" @mouseout="hoverStack = null" :key=deployment.stack_name class="members-list" v-bind:class="[ {'active-member': (activeStack == deployment.stack_name)},{'hover-member': (hoverStack == deployment.stack_name && activeStack != deployment.stack_name)},{'inactive-member': (activeStack != deployment.stack_name && hoverStack != deployment.stack_name)}]">{{ deployment.stack_name }}</dt>
                      <dd :key="deployment.stack_name + deployment.count.toString()">{{ deployment.count }}</dd>
                    </template>
                  </dl>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="column">
        <vue-good-table
          :columns="columns"
          :rows="filteredDeployments"
          :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Filter' }"
          :pagination-options="{ enabled: true, perPage: 20 }"
          styleClass="vgt-table condensed"
        >
        <template slot="table-actions">
          <button type="button" class="btn btn-sm btn-primary" v-on:click="downloadCSV()">Download Report</button>
        </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import DeploymentsGraph from '@/components/DeploymentsGraph'
import WorkCards from '@/components/Cards/WorkCards'
import { mapGetters } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  components: {
    DeploymentsGraph,
    WorkCards,
    VueLoading
  },
  props: [
    'id'
  ],
  data () {
    return {
      metrics: [],
      deployments: [],
      report: {
        date: null,
        members: [],
        contracts: [],
        deployments: []
      },
      interval: '',
      activeStack: null,
      hoverStack: null,
      hoverContract: null,
      date: null,
      loading: false,
      columns: [
        { label: 'Contract', field: 'Contract' },
        { label: 'Account Name', field: 'AccountName' },
        {
          label: 'Event Time',
          field: 'EventTime',
          formatFn: (value) => this.formatEventTime(value)
        },
        { label: 'Stack Name', field: 'stack_name' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'settings',
      'activeType'
    ]),
    formattedDeployments () {
      return this.deployments.map(deployment => ({
        ...deployment,
        stack_name: this.getResourceName(deployment.Resources)
      }))
    },
    filteredDeployments () {
      if (!this.activeStack) {
        return this.formattedDeployments
      }
      return this.formattedDeployments.filter(deployment => deployment.stack_name === this.activeStack)
    },
    displayBoards () {
      return this.report.contracts
    },
    displayStacks () {
      console.log(this.report)
      return this.report.stacks
    }
  },
  created: function () {
    this.getMetrics(true).then(() => {
      this.getDeployments(true, this.date)
    })
  },
  destroyed: function () {
    clearInterval(this.interval)
  },
  watch: {
    id: function () {
      this.report = {
        date: null,
        contracts: [],
        deployments: [],
        queue: null,
        cycle: null
      }
      this.getDeployments(true, this.date)
      this.getMetrics(true)
      this.hoverContract = null
    },
    report: {
      handler: function () {
        if (!this.report.deployments.map(deployments => deployments.StackName).includes(this.activeStack)) {
          this.activeStack = null
        }
      },
      deep: true
    }
  },
  methods: {
    getResourceName (resources) {
      if (resources && resources.length > 0) {
        return resources[0].ResourceName
      }
      return ''
    },
    dots: function (days) {
      let output = []
      if (days >= 5) {
        let dots = Math.floor(days / 5)
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#f070a1"><title>' + days + '</title></circle></svg>'))
      } else {
        let dots = days
        output.push(...Array(dots).fill('<svg height="6" width="10"><circle cx="3" cy="3" r="3" fill="#77a6f7"><title>' + days + '</title></circle></svg>'))
      }
      return output
    },
    getDeployments: function (showLoading, date) {
      this.loading = showLoading
      HTTP.get(`ciinabox/summary/${this.activeType}/${this.id}/${date}`)
        .then((response) => {
          this.report = response.data
          this.deployments = response.data.deployments
        })
        .catch((error) => {
          this.deployments = []
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get deployments: ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMetrics: function (showLoading) {
      this.loading = showLoading
      return HTTP.get(`/ciinabox/metrics/${this.activeType}/${this.id}/month`)
        .then((response) => {
          this.metrics = response.data['metrics']
          this.date = response.data['metrics'][11]['date']
        })
        .catch((error) => {
          this.metrics = []
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to get deployments metrics: ${msg}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateContract: function (contract) {
      this.$store.dispatch('SET_ACTIVE', contract)
    },
    updateMetric: function (event) {
      switch (event.eventType) {
        case 'date':
          console.log(event)
          this.date = event.data.date
          this.getDeployments(true, this.date)
          break

        default:
          console.log(event)
          break
      }
    },
    setActiveStack: function (stack) {
      if (this.activeStack === stack) {
        this.activeStack = null
      } else {
        this.activeStack = stack
      }
    },
    downloadCSV: function () {
      this.flashMessage.info({
        message: `Generating deployments CSV report`,
        time: 3000
      })
      HTTP.get(`ciinabox/summary/${this.activeType}/${this.id}/${this.date}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: `Deployments CSV report generation complete`
          })
        })
        .catch((error) => {
          var msg = (error.response) ? error.response.data.error : error.message
          this.flashMessage.error({
            message: `Failed to generate CSV report: ${msg}`
          })
        })
    },
    formatEventTime (eventTime) {
      const date = new Date(eventTime)
      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZoneName: 'short'
      }).format(date)
    }
  }
}
</script>
<style scoped src='../assets/stylesheet/cards.css'></style>



// WEBPACK FOOTER //
// src/views/CiinaboxDeployments.vue